<template>
  <div class="tw-bg-amber-50 tw-rounded-lg tw-p-3">
    <div class="tw-text-xs tw-font-semibold tw-text-amber-700 tw-uppercase tw-tracking-wide tw-mb-2">Breaker</div>
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
      <div class="tw-flex tw-items-center tw-gap-2">
        <span class="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-flex-shrink-0" :class="dotClass" />
        <span class="tw-text-sm tw-font-medium" :class="textClass">
          PV output {{ isKnown ? (breakerStatus === 'On' ? 'Actief' : 'Inactief') : 'onbekend' }}
        </span>
      </div>
      <button
        class="tw-bg-amber-500 hover:tw-bg-amber-600 tw-text-white tw-rounded-lg tw-py-1.5 tw-px-3 tw-font-semibold tw-text-sm tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:hover:tw-bg-amber-500"
        :disabled="isToggling || !!blockedReason"
        :title="blockedReason || ''"
        @click="$emit('toggle')"
      >
        <span class="tw-flex tw-items-center tw-gap-1">
          <lightning-bolt-icon class="tw-w-4 tw-h-4" />
          {{ breakerStatus === 'Off' ? 'Activeer' : 'Deactiveer' }}
        </span>
      </button>
    </div>
    <div v-if="blockedReason" class="tw-text-xs tw-text-amber-700 tw-mt-1">{{ blockedReason }}</div>
    <div v-if="note" class="tw-text-xs tw-mt-1" :class="noteIsError ? 'tw-text-red-600' : 'tw-text-gray-600'">{{ note }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { LightningBoltIcon } from '@vue-hero-icons/outline'

// The breaker switches the PV output through the polling server. Shown for meters that have one (see
// MeterPanel hasBreaker); when it cannot be switched from here the button is disabled with the reason.
const props = defineProps({
  breakerStatus: { type: String, default: null },
  isToggling: { type: Boolean, default: false },
  // set when switching is not possible now, e.g. a Cast4all switch still pending or no rights
  unavailableReason: { type: String, default: null },
  // why the status is unknown, and so why the toggle cannot pick a direction
  unknownReason: { type: String, default: 'Breakerstatus onbekend, poll de meter eerst' },
  // an extra line under the card, e.g. the outcome of the last switch
  note: { type: String, default: null },
  noteIsError: { type: Boolean, default: false },
})

defineEmits(['toggle'])

const isKnown = computed(() => props.breakerStatus === 'On' || props.breakerStatus === 'Off')

// without a known status the toggle would not know which way to switch
const blockedReason = computed(() =>
  props.unavailableReason || (isKnown.value ? null : props.unknownReason)
)

const dotClass = computed(() => {
  if (!isKnown.value) return 'tw-bg-gray-300'
  return props.breakerStatus === 'On' ? 'tw-bg-green-500' : 'tw-bg-red-500'
})
const textClass = computed(() => {
  if (!isKnown.value) return 'tw-text-gray-500'
  return props.breakerStatus === 'On' ? 'tw-text-green-700' : 'tw-text-red-700'
})
</script>
